import { Footer } from "../../components/layouts/footer";
import { Header } from "../../components/layouts/header";
import { BlueHero } from "../../contact/components/blue-hero";
import PrivacyPolicyData from "./components/privacy-policy-data";


export default function PrivacyPage() {
  return (
    <div className="bg-[#EFF3FD]">
      <Header />
      <BlueHero title="Privacy Policy" subtext="Effective Date" date="13th March, 2025" />
      <PrivacyPolicyData />
      <Footer />
    </div>
  );
}
